module.exports = __webpack_public_path__ + "static/media/buildings.04ed9e89.png";